import React, { useEffect, useRef, useState } from "react";
import "./Test_Page.css";
import { Button, Form, Pagination } from "react-bootstrap";
import Common_Btn from "../common/common-btn/Common_Btn";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Success_Modal from "../modals/success-modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";

import {
  FinalSubmit,
  GetAllExamQuestion,
  StudentResponse,
} from "../../redux/get_exam_questions";
import { useForm } from "react-hook-form";

const Test_Page = () => {
  const isSubmittedRef = useRef(false);
  const location = useLocation();
  const prevLocationRef = useRef(location);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const intervalRef = useRef(null);
  const storageKeyRef = useRef("languageTestEndTime");

  const [errorMsg, setErrorMsg] = useState("");

  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [answers, setAnswers] = useState({}); // ✅ store answers

  const all_questions = useSelector((state) => state?.get_exam_questions);

  console.log(all_questions, "all_questions");

  let currentPage = all_questions?.current_page || 1;

  console.log(currentPage, "currentPage");

  const totalPages = all_questions?.total_pages || 1;

  const timeDuration = all_questions?.data?.[0]?.User_Exam?.Exam?.time || 0;

  const initialSeconds = Number(timeDuration) * 60;

  console.log(initialSeconds, "initialSeconds");

  const [timeLeft, setTimeLeft] = useState(0);

  const [isStarted, setIsStarted] = useState(false);

  const startTest = async () => {
    try {
      await document.documentElement.requestFullscreen();
    } catch (err) {
      console.log(err);
    }
    setIsStarted(true);
  };

  useEffect(() => {
    if (!initialSeconds) return;

    let storedEndTime = localStorage.getItem(storageKeyRef.current);

    if (!storedEndTime) {
      const newEndTime = Date.now() + initialSeconds * 1000;
      localStorage.setItem(storageKeyRef.current, newEndTime);
      storedEndTime = newEndTime;
    }

    const updateTimer = () => {
      const remaining = Math.max(
        Math.floor((storedEndTime - Date.now()) / 1000),
        0,
      );

      setTimeLeft(remaining);

      if (remaining <= 0) {
        clearInterval(intervalRef.current);
        localStorage.removeItem(storageKeyRef.current);
        handleSubmitFinal();
      }
    };

    intervalRef.current = setInterval(updateTimer, 1000);
    updateTimer();

    return () => clearInterval(intervalRef.current);
  }, [initialSeconds]);

  useEffect(() => {
    const handleRightClick = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);

    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    formState: { errors, isSubmitting },
    getValues,
  } = useForm({
    defaultValues: {
      user_answer_id: all_questions[0]?.user_answer_id || "",
    },
  });

  const fetch = async (page = all_questions?.current_page) => {
    await dispatch(
      GetAllExamQuestion({
        id: id,
        page: page,
        per_page: 1,
      }),
    );
  };

  const handlePageChange = (page) => {
    if (page !== currentPage) {
      fetch(page);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const handleSave = async () => {
    try {
      const currentQuestion = all_questions?.data?.[0];

      if (!currentQuestion) return;

      const selectedAnswer = answers[currentQuestion.id];

      if (!selectedAnswer) {
        setErrorMsg("Please select an answer"); // ✅ no alert
        return;
      }

      setErrorMsg(""); // clear error

      const response = await dispatch(
        StudentResponse({
          id: currentQuestion.id,
          user_answer_id: selectedAnswer,
        }),
      );

      if (response.meta?.requestStatus === "fulfilled") {
        fetch();
        if (currentPage < totalPages) {
          await fetch(currentPage + 1);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const current = all_questions?.[0];

    if (current?.user_answer_id) {
      setAnswers((prev) => ({
        ...prev,
        [current.id]: current.user_answer_id,
      }));
    }
  }, [all_questions]);

  const handleSubmitFinal = async () => {
    if (isSubmittedRef.current) return;

    isSubmittedRef.current = true;
    setIsSubmitted(true);

    clearInterval(intervalRef.current);
    localStorage.removeItem(storageKeyRef.current);
    localStorage.removeItem("forceSubmit");

    try {
      const response = await dispatch(FinalSubmit(id));

      if (response.payload?.success) {
        setShowModal(true);

        setTimeout(() => {
          window.location.href = "/profile";
        }, 1500);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Strong Anti-Cheating Key Blocker
  // useEffect(() => {
  //   const blockKeys = (e) => {
  //     // Block F1 to F12
  //     if (e.key.startsWith("F") && e.key.length > 1) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block Escape
  //     if (e.key === "Escape") {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block Alt (including AltGr)
  //     if (e.altKey) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block Ctrl + anything (most dangerous shortcuts)
  //     if (e.ctrlKey) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block Meta key (Cmd on Mac)
  //     if (e.metaKey) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block specific dangerous combinations
  //     const dangerousKeys = ["i", "j", "u", "s", "p", "r", "t", "w", "Tab"];
  //     if (e.ctrlKey || e.shiftKey || e.altKey) {
  //       if (dangerousKeys.includes(e.key.toLowerCase())) {
  //         e.preventDefault();
  //         e.stopImmediatePropagation();
  //       }
  //     }

  //     // Block Shift + specific keys that open dev tools or menus
  //     if (e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //     }
  //   };

  //   // Add listeners with capture phase for better priority
  //   window.addEventListener("keydown", blockKeys, true);
  //   window.addEventListener("keyup", blockKeys, true); // extra safety
  //   window.addEventListener("keypress", blockKeys, true);

  //   return () => {
  //     window.removeEventListener("keydown", blockKeys, true);
  //     window.removeEventListener("keyup", blockKeys, true);
  //     window.removeEventListener("keypress", blockKeys, true);
  //   };
  // }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Block F1–F12
      if (e.keyCode >= 112 && e.keyCode <= 123) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block Ctrl combinations
      if (e.ctrlKey) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block Alt combinations (not 100% but helps)
      if (e.altKey) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block Escape
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block specific keys manually
      const blockedKeys = [
        "F1",
        "F2",
        "F3",
        "F4",
        "F5",
        "F6",
        "F7",
        "F8",
        "F9",
        "F10",
        "F11",
        "F12",
        "Alt",
        "Meta",
      ];

      if (blockedKeys.includes(e.key)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, []);

  useEffect(() => {
    const handleBlur = () => {
      console.log("Window lost focus");

      handleSubmitFinal();
    };

    window.addEventListener("blur", handleBlur);

    return () => {
      window.removeEventListener("blur", handleBlur);
    };
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      // ❌ If user exits fullscreen (ESC / F11 / browser control)
      if (!document.fullscreenElement) {
        console.log("Fullscreen exited 🚨");

        handleSubmitFinal(); // ✅ AUTO SUBMIT
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("User minimized / switched tab / pressed Windows key 🚨");

        handleSubmitFinal(); // ✅ AUTO SUBMIT
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    const handleKeyUp = (e) => {
      if (e.key === "PrintScreen") {
        // try clearing clipboard (works sometimes)
        navigator.clipboard.writeText("");

        alert("Screenshot detected! Submitting test...");
        handleSubmitFinal();
      }
    };

    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  useEffect(() => {
    const enterFullScreen = async () => {
      try {
        if (!document.fullscreenElement) {
          await document.documentElement.requestFullscreen();
        }
      } catch (err) {
        console.log("Fullscreen error:", err);
      }
    };

    console.log(enterFullScreen, "enterFullScreen");

    const handleFirstInteraction = () => {
      enterFullScreen();

      document.removeEventListener("click", handleFirstInteraction);
      document.removeEventListener("keydown", handleFirstInteraction);
    };

    document.addEventListener("click", handleFirstInteraction);
    document.addEventListener("keydown", handleFirstInteraction);

    return () => {
      document.removeEventListener("click", handleFirstInteraction);
      document.removeEventListener("keydown", handleFirstInteraction);
    };
  }, []);

  useEffect(() => {
    const handleBlur = () => {
      document.body.style.filter = "blur(10px)";
    };

    const handleFocus = () => {
      document.body.style.filter = "none";
    };

    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
    };
  }, []);

  {
    !isStarted && (
      <div className="start-overlay">
        <h2>Click to Start Test</h2>
        <Button onClick={startTest}>Start Test</Button>
      </div>
    );
  }

  return (
    <section className="Test_Page">
      <div className="container">
        <h5 className="text-end">
          Time Left: {Math.floor(timeLeft / 60)}:
          {String(timeLeft % 60).padStart(2, "0")}
        </h5>
        <Form className="question_div" onSubmit={handleSubmit}>
          {all_questions?.data?.map((q) => (
            <div className="question_card mb-4" key={q.id}>
              <h5 className="question_title mb-3">
                Que {currentPage}. {q.ExamQuestion?.question}
              </h5>

              <p>{q?.user_answer_id ? "✅ Attempted" : "❌ Not Attempted"}</p>

              {errorMsg && (
                <p
                  style={{
                    color: "red",
                    marginBottom: "10px",
                  }}
                >
                  {errorMsg}
                </p>
              )}

              {q.ExamQuestion?.ExamAnswers?.map((option, index) => (
                <div key={option.id} className="option_wrapper mb-3">
                  <div className="d-flex align-items-center">
                    <span className="me-2">{index + 1})</span>

                    <Form.Check
                      type="radio"
                      name={`question-${q.id}`}
                      id={`q${q.id}-o${option.id}`}
                      label={option.answer}
                      className="custom-radio"
                      onChange={() =>
                        setAnswers({
                          ...answers,
                          [q.id]: option.id,
                        })
                      }
                      checked={answers[q.id] === option.id}
                    />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </Form>
        {/* ✅ Buttons */}
        <div className="d-flex justify-content-between mb-3">
          <Common_Btn
            text="Previous"
            type="button"
            disabled={Number(currentPage) === 1}
            onClick={() => handlePageChange(currentPage - 1)}
            className={Number(currentPage) === 1 ? "next_btn" : ""}
          />

          {/* Save */}
          <Common_Btn text="Save" type="button" onClick={handleSave} />

          {
            <Common_Btn
              text="Next"
              type="button"
              disabled={Number(currentPage) === Number(totalPages)}
              onClick={() => {
                console.log("Saved Before Next:", answers);
                handlePageChange(currentPage + 1);
              }}
              className={
                Number(currentPage) === Number(totalPages) ? "next_btn" : ""
              }
            />
          }
        </div>

        <div className="pagination_holder">
          <div>
            <Button
              onClick={() => {
                handleSubmitFinal();
              }}
            >
              Submit
            </Button>
          </div>

          {/* ✅ Pagination */}
          <div className="pagination_div">
            <Pagination>
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              />

              {[...Array(totalPages)].map((_, index) => {
                const page = index + 1;
                return (
                  <Pagination.Item
                    key={page}
                    active={currentPage === page}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              })}

              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              />
            </Pagination>
          </div>
        </div>
      </div>
      <Success_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
        message={"Test Submitted Successfully"}
      />
    </section>
  );
};

export default Test_Page;
